import { render, staticRenderFns } from "./DebtRuleCard.vue?vue&type=template&id=a531d62e&"
import script from "./DebtRuleCard.vue?vue&type=script&lang=ts&"
export * from "./DebtRuleCard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports